import React from "react";
import ReactDOM from "react-dom";
import { FaExclamationTriangle, FaTimes, FaTrash } from "react-icons/fa";

export default function SuiviClientDeleteModal({
  association,
  saving,
  onClose,
  onConfirm,
}) {
  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/70 px-4 py-6 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="grid h-10 w-10 place-items-center rounded-full bg-red-100 text-red-600">
              <FaExclamationTriangle />
            </div>

            <div>
              <h2 className="text-lg font-bold text-slate-900">
                Supprimer la carte ?
              </h2>
              <p className="text-sm text-slate-500">
                Cette action est définitive.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="grid h-9 w-9 place-items-center rounded-full text-slate-500 hover:bg-slate-100"
          >
            <FaTimes />
          </button>
        </div>

        <div className="p-5">
          <p className="text-sm text-slate-600">
            Tu vas supprimer définitivement :
          </p>

          <div className="mt-3 rounded-xl border border-slate-200 bg-slate-50 p-4 font-bold text-slate-900">
            {association?.nom_asso || "Association sans nom"}
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 hover:bg-slate-100 disabled:opacity-60"
          >
            Annuler
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            className="inline-flex items-center gap-2 rounded-xl bg-red-600 px-4 py-2 text-sm font-bold text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaTrash />
            {saving ? "Suppression..." : "Supprimer"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}